<template>
  <section class="hero">
    <div class="hero__image"></div>
    <div class="hero__content">
      <h2>Independent Arbitrator and Mediator</h2>
      <h1>Julie G. Hopkins</h1>
      <p>A clear, logical approach</p>
      <div class="hero__content__links">
        <button @click="scrollToFooter" class="accent">Get in touch</button>
        <div>
          <a href="https://www.linkedin.com/in/julie-hopkins-062945321/?originalSubdomain=ca"
          target="_blank" class="hero__content__links-linkedin no-underline">
            <span class="hero__content__links-linkedin--icon">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="Primary" d="M4.25295 19H0.313839V6.31467H4.25295V19ZM2.28127 4.58428C1.02167 4.58428 0 3.54095 0 2.28132C9.01566e-09 1.67628 0.240348 1.09602 0.668169 0.668184C1.09599 0.240353 1.67624 0 2.28127 0C2.8863 0 3.46655 0.240353 3.89438 0.668184C4.3222 1.09602 4.56254 1.67628 4.56254 2.28132C4.56254 3.54095 3.54045 4.58428 2.28127 4.58428ZM18.9958 19H15.0651V12.8249C15.0651 11.3532 15.0354 9.46586 13.0171 9.46586C10.9691 9.46586 10.6553 11.0648 10.6553 12.7188V19H6.7204V6.31467H10.4983V8.04507H10.5535C11.0794 7.04839 12.364 5.99658 14.2805 5.99658C18.2671 5.99658 19 8.62187 19 12.0318V19H18.9958Z" fill="black"/>
              </svg>
            </span>
            <span>Linkedin</span>
          </a>
          <a download href="/julie-hopkins.vcf" target="_blank" rel="noopener noreferrer" class="hero__links-vcard no-underline">
            <span class="hero__links-vcard--icon">
              <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="Primary" d="M6.35591 7.5C7.31917 7.5 8.24297 7.12054 8.92409 6.44509C9.60521 5.76964 9.98786 4.85354 9.98786 3.89832C9.98786 2.94309 9.60521 2.02699 8.92409 1.35154C8.24297 0.676093 7.31917 0.296631 6.35591 0.296631C5.39266 0.296631 4.46886 0.676093 3.78774 1.35154C3.10661 2.02699 2.72396 2.94309 2.72396 3.89832C2.72396 4.85354 3.10661 5.76964 3.78774 6.44509C4.46886 7.12054 5.39266 7.5 6.35591 7.5ZM5.05919 8.85063C2.26429 8.85063 0 11.0961 0 13.8677C0 14.3291 0.377382 14.7034 0.842726 14.7034H11.8691C12.3344 14.7034 12.7118 14.3291 12.7118 13.8677C12.7118 11.0961 10.4475 8.85063 7.65263 8.85063H5.05919Z" fill="black"/>
              </svg>
              <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="Primary" d="M1.49284 0.733337C0.972964 0.733337 0.547607 1.16236 0.547607 1.68672C0.547607 2.21109 0.972964 2.64011 1.49284 2.64011H9.05475C9.57464 2.64011 9.99999 2.21109 9.99999 1.68672C9.99999 1.16236 9.57464 0.733337 9.05475 0.733337H1.49284ZM1.49284 4.54689C0.972964 4.54689 0.547607 4.97591 0.547607 5.50027C0.547607 6.02464 0.972964 6.45366 1.49284 6.45366H9.05475C9.57464 6.45366 9.99999 6.02464 9.99999 5.50027C9.99999 4.97591 9.57464 4.54689 9.05475 4.54689H1.49284ZM1.49284 8.36043C0.972964 8.36043 0.547607 8.78946 0.547607 9.31382C0.547607 9.83819 0.972964 10.2672 1.49284 10.2672H9.05475C9.57464 10.2672 9.99999 9.83819 9.99999 9.31382C9.99999 8.78946 9.57464 8.36043 9.05475 8.36043H1.49284Z" fill="black"/>
              </svg>
            </span>
            <span>vCard</span>
          </a>
        </div>
      </div>
      <!-- <p>I am a Canadian arbitrator and mediator based in Calgary, Alberta experienced in the resolution of both domestic and international commercial disputes.</p> -->
    </div>
  </section>
</template>

<script>
export default {
  name: 'Hero',
  props: {},
  methods: {
    scrollToFooter() {
      const footer = document.getElementById('footer');
      if (footer) {
        footer.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  &__image {
    background: url('../assets/hero-mobile-alt.jpg');
    background-size: cover;
    background-position: 0% 10%;
    height: 55vh;
  }

  &__content {
    color: $black;
    text-align: left;
    padding: 4.5rem 1.5rem 2.5rem;

    h2 {
      font-size: 1.25rem;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      margin-bottom: 0.5rem;

      &:before {
        top: -32px;
        background: $black;
        width: 67px;
      }

    }

    h1 {
      font-size: 2.5rem;
      font-weight: 900;
      line-height: normal;
      text-transform: uppercase;
      margin-bottom: 1rem;
    }

    p {
      font-size: 1.5rem;
      margin-bottom: 2.5rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__links {
      .no-underline {
        text-decoration: none;
      }
      button.accent {
        margin-bottom: 2.5rem;
        width: fit-content;
      }

      display: flex;
      flex-direction: column;

      a {
        display: inline-flex;
        align-items: center;
        text-transform: uppercase;
        font-size: 0.875rem;
        font-weight: 700;
        color: $black;

        span:first-child {
          height: 43px;
          width: 43px;
          border: 2px solid $black;
          border-radius: 110%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-right: 0.5rem;
        }

        &:last-child {
          margin-left: 1rem;
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .hero {
    position: relative;

    &__image {
      background: url('../assets/hero-alt.jpg') no-repeat;
      background-size: cover;
      background-position: 75% 10%;
      height: 680px;
    }
    
    &__content {
      position: absolute;
      top: 35%;
      left: 10%;
      right: 0;
      bottom: 0;
      padding: 0;

      h1 {
        font-size: 3.5rem;
      }

      p {
        font-size: 2rem;
      }

      &__links {
        button.accent {
          margin-bottom: 0;
          margin-right: 2.25rem;
        }
        flex-direction: row;
        align-items: center;

        a {
          color: white;
          font-size: 1.25rem;
          span:first-child {
            border: 2px solid white;
          }
          svg {
            path {
              fill: white;
            }
          }
          &:last-child {
            margin-left: 1.5rem;
          }
        }
      }
    }
  }
}
</style>
